import React, { useState, useEffect } from "react";
import { slice, concat } from "lodash";
import { useHistory } from "react-router-dom";
// import { ROUTES } from "../../route";
import SiteWrapper from "../../component/header";
import { Page, Grid, Card, Table, Button, Alert, Form } from "tabler-react";
import { SERVER_URL } from "../../utils/server.constant";
import axios from "axios";
import { ROUTES } from "../../route";
import { useLocation } from "react-router-dom";
import moment from 'moment'


const Dashboard = (props) => {
  const fileInput = React.createRef();
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [userList, setUserList] = useState([]);
  const [length, setLength] = useState(10);
  const [btnObj,setBtnObj]=useState({})

  const LENGTH = length;
  const DATA = [...Array(LENGTH).keys()];
  const LIMIT = 10;

  const [showMore, setShowMore] = useState(true);
  const [list, setList] = useState(slice(DATA, 0, LIMIT));
  const [index, setIndex] = useState(LIMIT);
  const [searchObj,setSearchObj]=useState({name:"",mobile:"",email:"",memberID:"",transactionID:""})

  const logout = async () => {
    await localStorage.clear();
    history.push(ROUTES.LOGIN);
  };
  const _getuser = async () => {
    const token = await localStorage.getItem("token");
    await axios
      .get(`${SERVER_URL}/user/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (res) => {
        setUserList(res?.data?.data);
        setLength(res?.data?.data?.length);

      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {

      if(location?.state?.success === 'Edit') {

        setSuccess("User Updated Successfully");
      }
      else if(location?.state?.success === 'Add') {

        setSuccess("User Added Successfully");
      }
      history.replace();

    
    _getuser();
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setError("");
      setSuccess("");
    }, 3000);
  });
  const onOpenFileDialog = () => {
    fileInput.current.click();
  };
  const onSearchChange=async ()=>{
    const token = await localStorage.getItem("token");
      await axios
        .post(`${SERVER_URL}/user/search`, searchObj, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (res) => {
          if(res?.data?.flag){
            setUserList(res?.data?.data)
            setLength(res?.data?.data?.length);
          }
          else{
            console.log('Server error')
          }
        })
        .catch((e) => {
          setError(e.response.data.info);
        });
  }

  useEffect(() => {
    onSearchChange()
}, [searchObj]);

  const handleChange = async (e) => {
    if (e) {
      const formData = new FormData();

      formData.append("file", e);
      const token = await localStorage.getItem("token");
      await axios
        .post(`${SERVER_URL}/user/bulk`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(async (res) => {
          console.log('Response:', res)
          if (res.data === "Only csv is allowed.") {
            setError(res.data);
          } else {
            _getuser();
            setSuccess("Bulk uploaded successfully");
          }
        })
        .catch((e) => {
          setError(e.response.data.info);
        });
    } else {
      console.log("select file");
    }
  };
  const downloadpdf = async (id) => {
    const token = await localStorage.getItem("token");
    await axios
      .get(
        `${SERVER_URL}/invoice/${id}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(async (res) => {
        window.open(
          res.data.data.file,
          "_blank",
          "toolbar=1, scrollbars=1, resizable=1, width=" +
            1015 +
            ", height=" +
            800
        );
      })
      .catch((e) => {
        console.log(e);
      });
    _getuser();
  };
  const _generatepdf = async (id) => {
    const token = await localStorage.getItem("token");
    await axios
      .post(
        `${SERVER_URL}/invoice`,
        { userID: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(async (res) => {
        console.log(res);
        window.open(
          res.data.data.file,
          "_blank",
          "toolbar=1, scrollbars=1, resizable=1, width=" +
            1015 +
            ", height=" +
            800
        );
      })
      .catch((e) => {
        console.log(e);
      });
    _getuser();
  };

  const loadMore = () => {
    const newIndex = index + LIMIT;
    const newShowMore = newIndex < LENGTH - 1;
    const newList = concat(list, slice(DATA, index, newIndex));
    setIndex(newIndex);
    setList(newList);
    setShowMore(newShowMore);
  };

  return (
    <>
      <SiteWrapper>
        <input
          onChange={(e) => {
            handleChange(e.target.files[0]);
          }}
          type="file"
          hidden={true}
          ref={fileInput}
        />
        <Page.Content>
          {error && <Alert type="danger">{error}</Alert>}
          {success && <Alert type="success">{success}</Alert>}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: 50,
            }}
          >
            <h1 className="page-title">Dashboard</h1>
            <Button.List align="right">
              <Button onClick={onOpenFileDialog} color="primary">
                Bulk Upload
              </Button>
            </Button.List>
          </div>
          
          <Grid.Row cards={true}>
            <Grid.Col width={12}>
              <Card title="Invoices">
                <div className="table-hover">
                  <Table
                    responsive
                    className="card-table table-vcenter text-nowrap"
                  >
                    <Table.ColHeader width={235}>
                      <Form.InputGroup
                            append={
                              !btnObj.btn1?<Button style={{width:10,height:10, backGroundColor:"white"}} icon="search" onClick={()=>{
                                let newObj={btn1:true,...btnObj}
                                setBtnObj(newObj)
                              }}>
                              </Button>:''
                            }
                          >
                            {btnObj.btn1?<Form.Input icon="search" placeholder="Search by name" onChange={(e)=>{
                               setSearchObj({...searchObj,name:e.target.value})
                            }} />:<div>Customer Name</div>}
                          </Form.InputGroup></Table.ColHeader>

                    <Table.ColHeader width={140}>
                      <Form.InputGroup
                            append={
                              !btnObj.btn2?<Button className="search" style={{width:10,height:10, marginLeft:5, backGroundColor:"white"}} icon="search" onClick={()=>{
                                let newObj={btn2:true,...btnObj}
                                setBtnObj(newObj)
                              }}>
                              </Button>:''
                            }
                          >
                            {btnObj.btn2?<Form.Input icon="search" placeholder="Search by mobile number" onChange={(e)=>{
                               setSearchObj({...searchObj,mobile:e.target.value})
                            }} />:'Mobile No.'}
                          </Form.InputGroup></Table.ColHeader>
                    <Table.ColHeader width={300}>
                      <Form.InputGroup
                            append={
                              !btnObj.btn3?<Button style={{width:10,height:10, marginLeft:5, backGroundColor:"white"}} icon="search" onClick={()=>{
                                let newObj={btn3:true,...btnObj}
                                setBtnObj(newObj)
                              }}>
                              </Button>:''
                            }
                          >
                            {btnObj.btn3?<Form.Input icon="search" placeholder="Search by email"  onChange={(e)=>{
                               setSearchObj({...searchObj,email:e.target.value})
                            }} />:'Email'}
                          </Form.InputGroup></Table.ColHeader>
                    <Table.ColHeader width={135}>
                      <Form.InputGroup
                            append={
                              !btnObj.btn4?<Button style={{width:10,height:10, marginLeft:5, backGroundColor:"white"}} icon="search" onClick={()=>{
                                let newObj={btn4:true,...btnObj}
                                setBtnObj(newObj)
                              }}>
                              </Button>:''
                            }
                          >
                            {btnObj.btn4?<Form.Input icon="search" placeholder="Search by member ID"  onChange={(e)=>{
                               setSearchObj({...searchObj,memberID:e.target.value})
                            }} />:'Member ID'}
                          </Form.InputGroup></Table.ColHeader>
                    <Table.ColHeader width={215}>
                      <Form.InputGroup
                            append={
                              !btnObj.btn5?<Button style={{width:10,height:10, marginLeft:5, backGroundColor:"white"}}icon="search" onClick={()=>{
                                let newObj={btn5:true,...btnObj}
                                setBtnObj(newObj)
                              }}>
                              </Button>:''
                            }
                          >
                            {btnObj.btn5?<Form.Input icon="search" placeholder="Search by transaction ID"  onChange={(e)=>{
                               setSearchObj({...searchObj,transactionID:e.target.value})
                            }} />:'Transaction ID'}
                          </Form.InputGroup></Table.ColHeader>
                    <Table.ColHeader width={80}>Created On</Table.ColHeader>      
                    <Table.ColHeader width={80}>Action</Table.ColHeader>
                    <Table.Body>
                      {userList.slice(0, list.length).map((i) => {
                        return (
                          <Table.Row>
                            <Table.Col>{i.name}</Table.Col>
                            <Table.Col>{i.mobile}</Table.Col>
                            <Table.Col>{i.email}</Table.Col>
                            <Table.Col>{i.memberID}</Table.Col>
                            <Table.Col>{i.transactionID}</Table.Col>
                            <Table.Col>{moment(i.created).format('DD/MM/YYYY')}</Table.Col>
                            <Table.Col>
                              <React.Fragment>
                                <Button
                                  onClick={() => {
                                    history.push({
                                      pathname: ROUTES.EDIT_USER,
                                    state:{
                                      user:  i
                                    }  
                                    });
                                  }}
                                  style={{ marginRight: "10px" }}
                                  size="sm"
                                  color="secondary"
                                  className="edit btn-btn"
                                >
                                  Edit
                                </Button>
                                <Button
                                  size="sm"
                                  onClick={() => {
                                    i?.isGenerated
                                      ? downloadpdf(i.id)
                                      : _generatepdf(i.id);
                                  }}
                                  color="secondary"
                                  className="btn-btn"
                                >
                                  {i?.isGenerated
                                    ? "Download Invoice"
                                    : "Generate Invoice"}
                                </Button>
                                {/* <Button size="sm" color="secondary">
                                  Delete
                                </Button> */}
                              </React.Fragment>
                            </Table.Col>
                          </Table.Row>
                        );
                      })}
                    </Table.Body>
                  </Table>
                </div>
                <tr
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {length > 10 && (
                    <div>
                      {showMore && (
                        <button
                          className="btn btn-sm btn-secondary edit btn-btn mb-10"
                          onClick={loadMore}
                        >
                          {" "}
                          Load More{" "}
                        </button>
                      )}
                    </div>
                  )}
                </tr>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Page.Content>
      </SiteWrapper>
    </>
  );
};
export default Dashboard;
